module.exports = __webpack_public_path__ + "static/cloudsud-71f882c43e8b8c26ebd31f029a74d95a.png";